var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "" } },
    [
      _c(
        "md-theme",
        { attrs: { "md-name": "blue" } },
        [
          _c("breadcrumbs", {
            attrs: { section: "Impersonate", nav: _vm.nav }
          }),
          _c(
            "md-layout",
            { staticClass: "form-wrapper", attrs: { "md-gutter": 16 } },
            [
              _c(
                "md-whiteframe",
                {
                  staticClass: "form-wrapper-frame",
                  attrs: { "md-elevation": "3" }
                },
                [
                  _c(
                    "h2",
                    { staticClass: "md-title", staticStyle: { flex: "1" } },
                    [_vm._v("Impersonate an Account")]
                  ),
                  _c("account-selector", {
                    attrs: {
                      canEdit: true,
                      hideAccountId: _vm.siteuser.user_metadata.account_id
                    },
                    model: {
                      value: _vm.account,
                      callback: function($$v) {
                        _vm.account = $$v
                      },
                      expression: "account"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "md-layout",
            { attrs: { "md-align": "center" } },
            [
              !_vm.impersonating
                ? _c(
                    "md-button",
                    {
                      staticClass: "md-raised md-primary",
                      attrs: { id: "submit-btn", "md-theme": "blue" },
                      on: { click: _vm.start }
                    },
                    [_vm._v("Impersonate")]
                  )
                : _vm._e(),
              _vm.impersonating && _vm.account
                ? _c(
                    "md-button",
                    {
                      staticClass: "md-raised md-primary",
                      attrs: { id: "submit-btn", "md-theme": "blue" },
                      on: { click: _vm.stop }
                    },
                    [_vm._v("Stop Impersonating")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f33e16b6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f33e16b6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/Impersonate.vue
// module id = 705
// module chunks = 0